export const PRECISION = 10
